export default __webpack_public_path__ + "static/media/sensotrend_connect_install_uploader1.80fe0d64.png";